// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__82anD","link":"Breadcrumbs_link__rUWls","text":"Breadcrumbs_text__rMzg0"};